import { PlatformTypeEnum } from '@/common/constants';
import { ScrollArea } from '@/components/ui/scroll-area';
import { useLoadStore } from '@/features/loads/store';
import useStore from '@/lib/store';
import { cn } from '@/lib/utils';
import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Pagination } from '../pagination/Pagination';
import { SidebarItem } from './SidebarItem';

interface SidebarProps {
  className?: string;
}

export const Sidebar: FC<SidebarProps> = ({ className }) => {
  const { t } = useTranslation();
  const { user } = useStore();
  const isCotton = user?.platform_type === PlatformTypeEnum.COTTON;

  const { loadList, loadGrainList, loadListLoading, loadGrainListLoading } =
    useLoadStore();

  const activeList = isCotton ? loadList : loadGrainList;

  const items = useMemo(() => {
    return Array.isArray(activeList?.content) ? activeList.content : [];
  }, [activeList?.content]);

  const totalElements = activeList?.totalElements || 0;
  const totalPages = activeList?.totalPages || 1;

  return (
    <div
      className={`flex flex-col w-[400px] min-w-[400px] bg-white h-[calc(100vh-107px)]  overflow-hidden border-r`}
    >
      <ScrollArea className={cn('flex-1', className)}>
        <div className="relative">
          {items.length === 0 ? (
            <div className="text-center text-black text-xl py-4">
              {t('no.data')}
            </div>
          ) : (
            items.map((item) => <SidebarItem key={item.id} item={item} />)
          )}
        </div>
      </ScrollArea>
      <div className="border-t bg-gray-50 h-[70px] flex items-center px-4">
        {totalElements > 0 && (
          <Pagination totalPages={totalPages} totalElements={totalElements} />
        )}
      </div>
    </div>
  );
};
